import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Skeleton, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import UploadButton from '../buttons/UploadButton';
import { NewsWithRoleName } from '../../store/NewsStore';
import { getNewsImagePath } from '../../firebaseConnection/storage';

const NewsMediaCard = observer(
  ({ newsElement }: { newsElement: NewsWithRoleName }): JSX.Element => {
    const [imageUrl, setImageUrl] = useState('');
    const [update, setUpdate] = useState(true);

    useEffect(() => {
      (async () => {
        if (newsElement.roleName && update) {
          const url = await getNewsImagePath(newsElement.imageFileName);
          setImageUrl(`${url}?timestamp=${new Date().getTime()}`);
          setUpdate(false);
        }
      })();
    }, [update]);

    return (
      <Card sx={{ maxWidth: 345, margin: ' 0 auto' }}>
        <TextField
          id="standard-basic"
          label="Titel"
          variant="standard"
          fullWidth
          value={newsElement.title}
          onChange={event => {
            newsElement.setTitle(event.target.value);
          }}
        />
        {imageUrl ? (
          <CardMedia
            component="img"
            height="140"
            image={imageUrl}
            alt={newsElement.title}
          />
        ) : (
          <Skeleton variant="rectangular" width="100%" height={140} />
        )}
        <br />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: 10,
          }}
        >
          <UploadButton
            key={newsElement.roleName}
            newsElement={newsElement}
            updateImage={() => setUpdate(true)}
          />
        </div>
        <CardContent>
          <TextField
            id="standard-basic"
            label="Link"
            variant="standard"
            fullWidth
            value={newsElement.url}
            onChange={event => {
              newsElement.setUrl(event.target.value);
            }}
          />
        </CardContent>
      </Card>
    );
  },
);

export default NewsMediaCard;
